import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { data, useFetcher } from "react-router";

import { TProgressData } from "@/types";

import Progresses from "./Progresses";

export async function loader() {
  const progressResponse = await fetch(`/api/client/onboardings/progress_data`);

  if (progressResponse.status !== 200) {
    throw data("Failed to load progress data", {
      status: progressResponse.status,
    });
  }

  const { data: progressData } = (await progressResponse.json()) as {
    data: TProgressData;
  };

  return {
    progressData,
  };
}

const OnboardingProgressSection = () => {
  const { t } = useTranslation("onboarding");
  const fetcher = useFetcher<typeof loader>();

  useEffect(() => {
    fetcher.submit({}, { action: "/onboarding/progress-data", method: "get" });
  }, []);

  return (
    <CardBackground className="col-span-3 lg:col-span-1">
      <div className="flex items-baseline justify-between">
        <Typography step="2" as="h2" weight="bold" className="mb-sm">
          {t("collect.title")}
        </Typography>
      </div>
      {fetcher.data ? (
        <Progresses progressData={fetcher.data.progressData} />
      ) : null}
    </CardBackground>
  );
};

export default OnboardingProgressSection;
